import { render, staticRenderFns } from "./AnnotationsListItem.vue?vue&type=template&id=67912138&scoped=true&"
import script from "./AnnotationsListItem.vue?vue&type=script&lang=js&"
export * from "./AnnotationsListItem.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationsListItem.vue?vue&type=style&index=0&id=67912138&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67912138",
  null
  
)

export default component.exports